import PropTypes from 'prop-types';

const TitleImage = ({ className = '', ...props }) => (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M33.2865 0H3.71353C1.6626 0 0 1.66261 0 3.71353V33.286C0 35.3369 1.6626 36.9995 3.71353 36.9995H33.2865C35.3374 36.9995 37 35.3369 37 33.286V3.71353C37 1.6626 35.3374 0 33.2865 0Z"
      fill="#FB6E44"
    />
    <path
      d="M18.6758 0.0107422C23.1219 0.236062 26.6572 3.91296 26.6572 8.41504V12.8691C26.6572 17.5163 22.8903 21.284 18.2432 21.2842L17.8096 21.2734C13.3636 21.0479 9.82812 17.3711 9.82812 12.8691V8.41504C9.82812 3.76777 13.5958 0 18.2432 0L18.6758 0.0107422ZM18.2432 3.97461C15.7908 3.97461 13.8027 5.96279 13.8027 8.41504V12.8691C13.8027 15.3214 15.7908 17.3096 18.2432 17.3096C20.6954 17.3094 22.6836 15.3213 22.6836 12.8691V8.41504C22.6836 5.96289 20.6954 3.97478 18.2432 3.97461Z"
      fill="#0A0777"
    />
    <path
      d="M18.4014 15.6951C22.3834 9.47091 32.7559 12.1593 32.7559 19.9428C32.7559 31.6488 18.4014 36.9999 18.4014 36.9999C18.4014 36.9999 4.04688 31.4258 4.04688 19.9428C4.04688 12.1593 14.4194 9.47091 18.4014 15.6951Z"
      fill="white"
    />
    <path
      d="M21.968 22.4049C21.968 20.5039 20.4152 18.9624 18.4998 18.9624C16.5844 18.9624 15.0312 20.5035 15.0312 22.4049C15.0312 23.8515 15.9314 25.0877 17.2052 25.5968L15.2065 30.5248H21.7935L19.7948 25.5968C21.0686 25.0873 21.9687 23.8515 21.9687 22.4049H21.968Z"
      fill="#0A0777"
    />
  </svg>
);

TitleImage.propTypes = {
  className: PropTypes.string
};

export default TitleImage;
